import {
  Avatar,
  Badge,
  Card,
  ListItem,
  ListItemContent,
  ListItemDecorator,
  Stack,
  Typography,
} from "@mui/joy";
import * as React from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router";
import { CryptoCurrencyFormat, CurrencyFormat } from "../config/services";

export default function AssetItems() {
  const walletData = useSelector((state) => state.walletsData);

  return (
    <Stack direction="column" spacing={2}>
      {walletData.map((coin, index) => (
        <Link
          to={"/coin"}
          state={{ coin: coin }}
          style={{ textDecoration: "none" }}
          key={index}
        >
          <Card onClick={() => console.log("olll")} variant="outlined">
            <ListItem>
              <ListItemDecorator>
                <Badge
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  variant="plain"
                  badgeContent={
                    <Avatar
                      variant="plain"
                      alt="Remy Sharp"
                      src={coin.thumbimage}
                      sx={{ "--Avatar-size": "16px" }}
                    />
                  }
                  badgeInset="14%"
                  sx={{ "--Badge-paddingX": "0px" }}
                  slotProps={{ badge: { style: { boxShadow: "none" } } }}
                >
                  <Avatar src={coin.image} size="md" />
                </Badge>
              </ListItemDecorator>

              <ListItemContent>
                <Stack direction="column" spacing={1} ml={2}>
                  <Typography level="body-lg">{coin.code}</Typography>

                  <Typography level="title-sm">
                    <CurrencyFormat
                      amount={coin.price}
                      prefix="$"
                      seperator={true}
                    />{" "}
                    <font
                      color={coin.difference < 0 ? "orangered" : "springgreen"}
                    >
                      {coin.difference.toFixed(2)}%
                    </font>
                  </Typography>
                </Stack>
              </ListItemContent>
              <Stack direction="column" spacing={1} alignItems="end">
                <Typography level="title-md">
                  {coin.balancecoin == 0 ? (
                    `0.00`
                  ) : (
                    <CryptoCurrencyFormat
                      amount={coin.balancecoin}
                      // suffix={` ${coin.code}`}
                    />
                  )}
                </Typography>
                <Typography level="title-sm">
                  <CurrencyFormat
                    amount={coin.balance}
                    prefix="$"
                    seperator={true}
                  />
                </Typography>
              </Stack>
            </ListItem>
          </Card>
        </Link>
      ))}
    </Stack>
  );
}
